import { uploadBytes, type StorageReference } from 'firebase/storage'

export const uploadFile = (storageRef: StorageReference, file: File) => {
    return uploadBytes(storageRef, file, {
        contentType: file.type,
        cacheControl: 'public, max-age=31536000',
    })
}
